// Locales our app supports
const locales = {
	it: 'Italiano',
	de: 'Deutsche',
	en: 'English',
};
// Locale to show when we don't support the
// requested locale
const fallbackLocale = 'it';
export { locales, fallbackLocale };
